import { API_VALIDATION_CONTRACTS } from "../generated/apiValidationContracts";

export type TextLengthRule = { readonly min_length?: number; readonly max_length?: number };

export function boundedTextError(label: string, value: string, rule: TextLengthRule, trim = true): string | null {
  const candidate = trim ? value.trim() : value;
  if (rule.min_length !== undefined && candidate.length < rule.min_length) {
    return `${label} muss mindestens ${rule.min_length} Zeichen lang sein.`;
  }
  if (rule.max_length !== undefined && candidate.length > rule.max_length) {
    return `${label} darf höchstens ${rule.max_length} Zeichen lang sein.`;
  }
  return null;
}

export function isBoundedTextValid(value: string, rule: TextLengthRule, trim = true): boolean {
  return boundedTextError("Wert", value, rule, trim) === null;
}

export const AUTH_VALIDATION = API_VALIDATION_CONTRACTS.auth;
export const SETTINGS_VALIDATION = API_VALIDATION_CONTRACTS.settings;
export const STORAGE_OWNERSHIP_VALIDATION = API_VALIDATION_CONTRACTS.storage_ownership;
export const VISUAL_LAB_VALIDATION = API_VALIDATION_CONTRACTS.visual_lab;
export const VISION_OPTIMIZER_VALIDATION = API_VALIDATION_CONTRACTS.vision_optimizer;
